import React from 'react';

import { Message } from '@/api/messaging/types.ts';
import { ViewMessageType } from '@/enums/viewEnums.ts';
import { getMessageType } from '@/pages/Messenger/utils/common.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';

interface ReplyMessageProps {
  replyMessage: Message;
  contactName?: string;
  onReplyClick?: () => void;
  onCancelReply?: () => void;
  showCancelButton?: boolean;
}

const truncateText = (text: string, maxLength: number = 50) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const ReplyMessage: React.FC<ReplyMessageProps> = ({
  replyMessage,
  contactName,
  onReplyClick,
  onCancelReply,
  showCancelButton = false
}) => {
  const { aboutMe } = useProfileStore();

  const replyMessageType: ViewMessageType = getMessageType(
    replyMessage.labels,
    replyMessage.type
  );

  const replyContactName =
    replyMessageType === ViewMessageType.INBOX
      ? contactName
      : aboutMe?.profile.name;

  return (
    <div
      onMouseDown={(e) => e.preventDefault()}
      onClick={onReplyClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px',
        marginBottom: showCancelButton ? '8px' : '4px',
        backgroundColor: 'rgba(0, 0, 0, 0.025)',
        borderLeft: '3px solid #917d5b',
        cursor: onReplyClick ? 'pointer' : 'default',
        borderRadius: '4px',
        alignSelf: 'flex-start',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      <div style={{ flex: 1, overflow: 'hidden' }}>
        {replyContactName && (
          <div
            style={{
              fontSize: '12px',
              color: '#917d5b',
              fontWeight: '600',
              marginBottom: '2px'
            }}
          >
            {replyContactName}
          </div>
        )}
        <div
          style={{
            fontSize: '14px',
            color: '#333',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {truncateText(replyMessage?.text_body?.message ?? '')}
        </div>
      </div>
      {showCancelButton && onCancelReply && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCancelReply();
          }}
          style={{
            marginLeft: '8px',
            background: 'none',
            border: 'none',
            fontSize: '20px',
            color: '#666',
            cursor: 'pointer',
            padding: '4px 8px'
          }}
        >
          ✕
        </button>
      )}
    </div>
  );
};
